import { Directive, HostListener, ElementRef } from '@angular/core';
import { GoogleAnalyticsService } from '../services/google-analytics.service';
import { Router} from '@angular/router';
import { Constants } from '../utilities/constants.util';

@Directive({
  selector: '[smtGAEventTracker]'
})

export class GoogleAnalyticsEventTrackerDirective {

  constructor(private googleAnalyticsService: GoogleAnalyticsService, private router: Router) { }

  @HostListener('click', ['$event']) trackEvent(event: MouseEvent) {
    let trackingElement = <HTMLInputElement>event.target;       
    if (trackingElement.type == Constants.GATrackingButton || trackingElement.type == Constants.GATrackingSubmit) {  
      let routeValues = this.router.url.split("/");   
      this.googleAnalyticsService.trackEvent(
        Constants.GAClickEvent,
        trackingElement.innerText,
        routeValues[Constants.GAEventCategoryIndex],
        routeValues[Constants.GAEventLabelIndex],
        this.router.url        
      );     
    }
  }
}
